import validate from 'validate.js';

export default function (data, constraints) {
  let jsValidationErrors;

  jsValidationErrors = validate(data, constraints, {
    format: 'detailed',
  });

  if (jsValidationErrors === undefined) {
    return true;
  } else {
    let errors = {};

    jsValidationErrors.map((d) => {
      errors[d.attribute] = d.error;
      return d;
    });
    // console.log('errors:', errors);
    return errors;
  }
}
